{
  "version": 1,
  "asset_id": "9ea110f9-e416-4d1a-9bf4-c76121864d64",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/9ea110f9-e416-4d1a-9bf4-c76121864d64/hiatal-type-3-second-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/9ea110f9-e416-4d1a-9bf4-c76121864d64/hiatal-type-3-second-es-800.webp",
  "original_filename": "hiatal-type-3-second-es-800.webp",
  "size": 69340,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:53:42Z"
}
